(() => {
  const initialized = new WeakSet();

  const initialize = (root = document) => {
    const sections = root.matches?.('.testimonials')
      ? [root]
      : Array.from(root.querySelectorAll('.testimonials'));

    sections.forEach((section) => {
      if (initialized.has(section)) return;

      const slider = section.querySelector('.testimonials__list--desktop-slider, .testimonials__list--mobile-slider');
      const controls = section.querySelector('[data-testimonials-controls]');
      if (!slider || !controls) return;

      const previous = controls.querySelector('[data-testimonials-prev]');
      const next = controls.querySelector('[data-testimonials-next]');
      if (!previous || !next) return;

      initialized.add(section);

      const move = (direction) => {
        slider.scrollBy({ left: direction * slider.clientWidth, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
